import { Observable } from "rxjs";
import { CheckrideRequestSchoolCalendarQueryEntity } from "../../../../meta-data/app-meta-data.service";
import { EventSearchRequestDTO } from "../../models/event-search-request.model";
import { ScheduleBlockCalendarEvent } from "../../../schedule-blocks/models/schedule-block-calendar-event.model";
import { CheckrideReferenceInfo } from "../../../examiner/models/checkride-reschedule-info.model";
import { CalendarDTO } from "../../models/calendar.model";
import { DwQueryMetaData } from "@devwareapps/devware-cap";
import { InjectionToken } from "@angular/core";
import { CalendarEventDTO } from "../../models/calendar-event.model";

export const CalendarControllerToken: InjectionToken<CalendarControllerService> = new InjectionToken<CalendarControllerService>('CalendarControllerService');
 
export interface CalendarControllerService {
    getScheduleBlocks(eventSearchRequest: EventSearchRequestDTO, scheduleBlockId?: number): Observable<ScheduleBlockCalendarEvent[]>;

    getCheckrides(eventSearchRequest: EventSearchRequestDTO, queryMetaData: DwQueryMetaData): Observable<CheckrideRequestSchoolCalendarQueryEntity[]>;

    getCalendarEvents(request: EventSearchRequestDTO): Observable<CalendarEventDTO[]>;

    useBlockBooking(): boolean;

    getCurrentCalendarRef(): Observable<any>;

    getCalendarMenu(): string;

    getCalendars(): Observable<CalendarDTO[]>
    setCheckrideReferenceInfo(CheckRideRequestId: number, rescheduleInfo: CheckrideReferenceInfo): unknown;

    loadSetupData(): Observable<any>;

    allowCalendarIntegration(): boolean;

    getOwnershipTypeId(): number;

    canEditScheduleBlock(scheduleBlock: ScheduleBlockCalendarEvent): boolean;


    getEventDisplayOptions() : { showSchool: boolean, showExaminer: boolean }
}
